import { render, staticRenderFns } from "./myPage.vue?vue&type=template&id=592b9271&scoped=true"
import script from "./myPage.vue?vue&type=script&lang=js"
export * from "./myPage.vue?vue&type=script&lang=js"
import style0 from "./myPage.vue?vue&type=style&index=0&id=592b9271&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592b9271",
  null
  
)

export default component.exports